export enum PerfisEnum {
  Administrador = "Administrador",
  Agrodrive = "Agrodrive",
  Agronomo = "Agenda de Campo - Agrônomo",
  Basico = "Básico",
  Gerente_Unidade = "Agenda de Campo - Gerente de Unidade",
  Gerente_Regional = "Agenda de Campo - Gerente Regional",
  Indicadores_Financeiros = "Indicadores Financeiros (AgroDASH)",
}
